import { render, staticRenderFns } from "./pd-product-video.vue?vue&type=template&id=cc725004&"
import script from "./pd-product-video.vue?vue&type=script&lang=js&"
export * from "./pd-product-video.vue?vue&type=script&lang=js&"
import style0 from "./pd-product-video.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SgImg: require('/opt/build/repo/storefront/components/legacy/global/sg-img.vue').default})
